import { type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { UserRole } from '@kn/shared';
import { useAuth } from '../auth/auth-context';

interface RequireAuthProps {
  children: ReactNode;
  /** Roles autorises ; absent = toute session valide. */
  roles?: UserRole[];
  /** Autorise l'acces alors qu'un changement de mot de passe est encore requis. */
  allowPendingPasswordChange?: boolean;
}

export function RequireAuth({
  children,
  roles,
  allowPendingPasswordChange = false,
}: RequireAuthProps): ReactElement {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <p className="chargement">Chargement de la session...</p>;
  }

  if (!user) {
    // Chemin **et** query : un lien partage vers une fiche doit revenir
    // entier apres la connexion, pas ampute de ses parametres.
    const demande = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/connexion" replace state={{ from: demande }} />;
  }

  if (user.mustChangePassword && !allowPendingPasswordChange) {
    return <Navigate to="/changer-mot-de-passe" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return (
      <div className="carte">
        <h1>Accès refuse</h1>
        <p className="sous-titre">
          Votre rôle ne vous permet pas de consulter cette page. Contactez un administrateur.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
